import { cloneDeep } from 'lodash';
import type { ILayerProps, IMarkupDrawConfig, IMarkupLayerProps, ISize } from '@/version-types';
import { clampFillWidth, clampFontSize } from '../../utils/size';

const DRAW_CONFIG_BASE_WIDTH = 800;

/** 将业务绘制配置转换为当前画布下的稳定初始数据。 */
export function adaptDrawMarkupConfig(drawConfig: IMarkupDrawConfig, currentWidth: number) {
    const data = cloneDeep(drawConfig);
    const ratio = currentWidth / DRAW_CONFIG_BASE_WIDTH;
    data.label.fontSize = clampFontSize(data.label.fontSize * ratio);
    data.fill.width = clampFillWidth(data.fill.width * ratio);
    data.anchor.arrowLeft[0] = Math.ceil(data.anchor.arrowLeft[0] * ratio);
    data.anchor.arrowLeft[1] = Math.ceil(data.anchor.arrowLeft[1] * ratio);
    data.anchor.arrowRight[0] = Math.ceil(data.anchor.arrowRight[0] * ratio);
    data.anchor.arrowRight[1] = Math.ceil(data.anchor.arrowRight[1] * ratio);
    return data;
}

/** 每次拟合都从画布适配后的初始字号开始，不使用上一帧已经压缩的预览字号。 */
export function getDrawArrowLabelSize(
    layer: ILayerProps,
    initialFontSize: number,
    labelKit: {
        getFontSize: (layer: ILayerProps, fontSize: number, width: number) => (ISize & { fontSize: number }) | null;
    },
) {
    return labelKit.getFontSize(layer, initialFontSize, layer.width);
}

/** 布局成功后才同步文字几何与背景圆角，失败时保留原数据。 */
export function applyDrawLabelLayout(
    layer: ILayerProps,
    size: (ISize & { fontSize?: number }) | null | undefined,
    getRoundWeight: (layer: ILayerProps) => number,
) {
    if (!size) return false;
    const { label } = layer.data as IMarkupLayerProps;
    Object.assign(label, size);
    label.roundWeight = getRoundWeight(layer);
    return true;
}
